<template>
    <breeze-authenticated-layout>
        <template #header>
            <h2 class="font-semibold text-3xl text-gray-800 leading-tight py-2">
                T&C
            </h2>
        </template>

        <breeze-page>
            <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg">
                <breeze-table :searchable="true" :fields="fields" :items="terms"
                              :action="{'text':'add T&C','url':route('term.create')}"
                              :searchlink="route('term.search')"
                              :canView="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'View Term')"
                              :canCreate="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create Term')">
                    <template #title="data">
                        {{ data.item.branch ? data.item?.branch?.title + ' Branch' : (data.item.type.charAt(0).toUpperCase() + data.item.type.slice(1)) }}
                    </template>
                    <template #updated_at="data">
                        {{ convertDateTime(data.item.updated_at) }}
                    </template>
                    <template #action="data">
                        <button-link
                            v-if="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Edit Term')"
                            :href="route('term.edit',data.item.id)">Edit
                        </button-link>
                    </template>
                </breeze-table>
            </div>
        </breeze-page>
    </breeze-authenticated-layout>
</template>

<script>
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated'
import BreezePage from '@/Components/Page'
import BreezeTable from '@/Components/Table'
import ButtonLink from '@/Components/ButtonLink'

export default {
    components: {
        BreezeTable,
        ButtonLink,
        BreezeAuthenticatedLayout,
        BreezePage
    },
    props: ['terms'],
    data() {
        return {
            fields: [{'key': 'title', 'label': 'Title'}, {'key': 'updated_at', 'label': 'Last Updated'}, {
                'key': 'action',
                'label': 'Action'
            }]
        }
    }
}
</script>
